import { render, staticRenderFns } from "./commentbox.vue?vue&type=template&id=64f2e61e&scoped=true"
import script from "./commentbox.vue?vue&type=script&lang=js"
export * from "./commentbox.vue?vue&type=script&lang=js"
import style0 from "./commentbox.vue?vue&type=style&index=0&id=64f2e61e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f2e61e",
  null
  
)

export default component.exports